import { IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { alertCircle, chatboxEllipses, checkmarkCircleOutline, radioButtonOff } from 'ionicons/icons';
import { getStateStringAsMoment } from '../../../common/util';
import { ITechComment } from '../../../models/dms/technicianComments.model';

interface IComponentProps {
  techComment: ITechComment;
  onClick: (techComment: ITechComment) => void;
  errorMessage?: string;
  lines?: 'full' | 'inset' | 'none';
}

const TechnicianCommentItem: React.FC<IComponentProps> = ({ techComment, onClick, errorMessage, lines }) => {
  return (
    <>
      <IonItem lines={lines} button onClick={() => onClick(techComment)} className="flexed-fill ion-activatable ripple-card">
        {techComment.unSync && <IonSpinner name="lines-small" slot="end" color="secondary" />}

        {!techComment.actioned && <IonIcon icon={radioButtonOff} slot="end" color="medium" />}
        {techComment.actioned && <IonIcon icon={checkmarkCircleOutline} slot="end" color="success" />}

        {!techComment.isAlert && <IonIcon icon={chatboxEllipses} slot="start" color="medium" size="large" />}
        {techComment.isAlert && <IonIcon icon={alertCircle} slot="start" color="warning" size="large" />}
        <IonLabel>
          <IonText color="medium">
            <p className="date-label">{getStateStringAsMoment(techComment.createdDateTime).format('MMM DD, YYYY HH:mm:ss')}</p>
          </IonText>
          <h2 className="ion-text-capitalize"><strong>{techComment.technicianDisplayName}</strong></h2>
          <IonLabel className="ion-text-wrap ellipsis-wrap">{techComment.comment}</IonLabel>
        </IonLabel>
      </IonItem>
      {errorMessage ? <IonItem lines="none">
        <IonLabel color="danger">{errorMessage}</IonLabel>
      </IonItem> : <></>}
    </>
  );
};

export default TechnicianCommentItem;
